<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="terms" />

		<article class="gb-legal">
			<hh1>Terms and Conditions</hh1>
			<p>
				By accessing and using
				<a class="jump-url" href="https://gbappss.co/">gbappss.co</a>,
				you agree to follow these terms and conditions.
			</p>
			<p>
				The information provided on this website is intended for general informational purposes related to GB
				WhatsApp, APK files, guides, and Android applications.
			</p>

			<hh2>Website Usage</hh2>
			<p>Users agree to:</p>
			<ul>
				<li>Use the website responsibly</li>
				<li>Not misuse website resources</li>
				<li>Not attempt to damage or disrupt website operations</li>
			</ul>

			<hh2>Content Accuracy</hh2>
			<p>
				We make efforts to keep information updated and accurate. However, application versions, features, and
				compatibility may change over time.
			</p>
			<p>We do not guarantee that every APK version or feature will work on all devices.</p>

			<hh2>Third-Party Applications</hh2>
			<p>
				GB Apps provides information about third-party applications. We are not the developers of GB WhatsApp
				and are not affiliated with WhatsApp or Meta.
			</p>
			<p>Users should make their own decisions before installing third-party applications.</p>

			<hh2>External Links</hh2>
			<p>
				Our website may contain links to external websites. We are not responsible for the content, privacy
				policies, or practices of third-party websites.
			</p>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'Terms',
	components: { HeadNav },
}
</script>
